import React from 'react';
import { useToast } from '../context/ToastContext';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import './Toast.css';

export default function Toast() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="region" aria-label="Notifications">
      {toasts.map(({ id, message, type }) => (
        <div
          key={id}
          className={`toast toast-${type}`}
          role="alert"
          onAnimationEnd={() => {}}
        >
          {type === 'success' && <FiCheckCircle className="toast-icon" aria-hidden="true" />}
          {type === 'error' && <FiAlertCircle className="toast-icon" aria-hidden="true" />}
          <span className="toast-message">{message}</span>
          <button
            type="button"
            className="toast-dismiss"
            onClick={() => removeToast(id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
